<template>
  <section class="mail-profile-search" aria-label="TAC-Mitglied suchen">
    <form class="mail-profile-fields" @submit.prevent="search">
      <label>Vorname<input v-model="firstName" autocomplete="off" maxlength="100" :disabled="loading || busy" @input="reset" /></label>
      <label>Nachname<input v-model="lastName" autocomplete="off" maxlength="100" :disabled="loading || busy" @input="reset" /></label>
      <button type="submit" :disabled="loading || busy || !canSearch"><v-icon aria-hidden="true">mdi-magnify</v-icon>{{ loading ? 'Sucht …' : 'Im TAC suchen' }}</button>
    </form>
    <p v-if="error" class="mail-notice error" role="alert">{{ error }}</p>
    <p v-if="searched" class="muted" role="status">{{ profiles.length ? profiles.length + ' Treffer. Bitte das passende Mitglied wählen.' : 'Keine Mitglieder gefunden.' }}<template v-if="limited"> Bitte die Suche weiter eingrenzen.</template></p>
    <ul v-if="profiles.length" class="mail-profile-results">
      <li v-for="profile in profiles" :key="profile.id">
        <div><strong>{{ profile.firstName }} {{ profile.lastName }}</strong><span class="muted">{{ profile.email || 'Keine gültige E-Mail im TAC – bitte dort ergänzen.' }}</span><span class="muted">{{ [profile.zip, profile.city].filter(Boolean).join(' ') }} · TAC {{ profile.id }}</span></div>
        <button type="button" :disabled="busy || loading || !!linking || !profile.email" @click="select(profile)">{{ linking === profile.id ? 'Lädt …' : 'Verknüpfen' }}</button>
      </li>
    </ul>
  </section>
</template>
<script>
import api, { errorText } from "@/api/aiMails"
export default {
  props: { busy: Boolean, onSelect: { type: Function, required: true } },
  data: () => ({ firstName: "", lastName: "", profiles: [], searched: false, limited: false, loading: false, linking: "", error: "", stopped: false }),
  computed: { canSearch() { return this.firstName.trim().length + this.lastName.trim().length >= 2 } },
  beforeDestroy() { this.stopped = true },
  methods: {
    reset() { this.profiles = []; this.searched = false; this.limited = false; this.error = "" },
    async search() {
      if (!this.canSearch || this.loading || this.busy || this.linking) return
      this.reset(); this.loading = true
      try {
        const result = await api.searchProfiles({ firstName: this.firstName.trim(), lastName: this.lastName.trim() })
        if (!this.stopped) { this.profiles = result.profiles; this.limited = result.limited; this.searched = true }
      } catch (error) { if (!this.stopped) this.error = errorText(error) }
      finally { this.loading = false }
    },
    async select(profile) {
      if (this.busy || this.loading || this.linking || !profile.email) return
      this.linking = profile.id; this.error = ""
      try { await this.onSelect(profile); if (!this.stopped) this.reset() }
      catch (error) { if (!this.stopped) this.error = errorText(error) }
      finally { this.linking = "" }
    },
  },
}
</script>
